module.exports = __webpack_public_path__ + "static/media/1.ece3a2bd.png";